module.exports = __webpack_public_path__ + "static/img/gather.5a1c9e2b.png";